export default {
  accepted: {
    title: 'Signature Accepted',
    description: 'Signature accepted. Thank you for using our delivery service!',
  },
  info: 'You have a delivery from',
  title: 'Please verify your information:',
  fields: {
    name: 'Recipient Name:',
    phone: 'Recipient Phone:',
    address: 'Recipient Address:',
    'rx-number': 'Rx Number:',
  },
  'action-btn': 'Submit',
  'empty-signature': 'Please draw your signature before submitting.',
  'heading-required': 'Signature required',
  'heading-optional': 'Signature optional',
  'heading-change': 'You have already signed. Do you want to change your signature?',
}
